import React, { useState } from 'react'
import { FaCamera, FaTimes, FaVideo } from 'react-icons/fa';
import { HiOutlineTrash } from 'react-icons/hi';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { CollectionModalComponet } from '../../../../models/collection-modal';
import UploadFilesContainer from '../../../../models/upload-url-file';
import BrandMappingContainer from '../../card-types/containers/brand-mapping';
import TemplateContainer from '../../card-types/containers/template';
import SocialProfileContainer from '../../card-types/containers/social-profile';
import AnnouncementContainer from '../../card-types/containers/announcement';
import BlogPostContainer from '../../card-types/containers/blog-post';
import HelpTopicContainer from '../../card-types/containers/help-topic';


export default function UpdateCardComponent({cardDetailInfo,cardTypes,webPageCards,handleInnerFormChange,isModalOpen,isModalProductOpen,handleOpenModal,handleCloseModal,
  handleOpenProductModal,handleCloseProductModal,additionButtons,onSelect,categoryColumnDefs,productsPaginationData,productColumnDefs,categories,products,categoriesPaginationData,setPageData,changeCardFile,deletewebPageCardItem,cardTemplate,handleFormChange,cardValues}: any) {
  const [isModalMediaOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const [imageUrls, setImageUrls] = useState<string[]>([]); // Array to store multiple URLs
  // Function to handle URL save
  const handleSaveUrls = (urls: string[]) => {
    setImageUrls(urls); // Set the new array of URLs
    webPageCards.cardDetailInfo =urls.map((url, index) => ({
        Id: 0,
        OwnerTypeId: 0,
        OwnerId: 0,
        FileTypeId:10,
        Name: "string",
        Description: "string",
        FileMappingURL: url,
        IsApproved: true
    }))
    closeModal(); // Close the modal after saving URLs
  };

  const [isBrandMappingModalOpen, setBrandMappingModalOpen] = useState(false);
  const openBrandMappingModal = () => {
    setBrandMappingModalOpen(true);
  };
  const closeBrandMappingModal = () => {
    setBrandMappingModalOpen(false);
  };
  const handleBrandMappingsSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo = mappings,
    closeBrandMappingModal()
  };


  const [isTemplateModalOpen, setTemplateModalOpen] = useState(false);
  const openTemplateModal = () => {
    setTemplateModalOpen(true);
  };

  const closeTemplateModal = () => {
    setTemplateModalOpen(false);
  };
  const handleTemplatesSubmit = (mappings: any) => {
    console.log(mappings,'mappings')
    webPageCards.cardDetailInfo= mappings;
    closeTemplateModal()
  };


    const [isHelpTopicModalOpen, setHelpTopicModalOpen] = useState(false);
    const openHelpTopicModal = () => {
      setHelpTopicModalOpen(true);
    };
  
    const closeHelpTopicModal = () => {
      setHelpTopicModalOpen(false);
    };
    const handleHelpTopicSubmit = (mappings: any) => {
      webPageCards.cardDetailInfo= mappings;
      closeHelpTopicModal()
    };
  
  const [isSocialProfileModalOpen, setSocialProfileModalOpen] = useState(false);
  const openSocialProfileModal = () => {
    setSocialProfileModalOpen(true);
  };

  const closeSocialProfileModal = () => {
    setSocialProfileModalOpen(false);
  };
  const handleSocialProfilesSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeSocialProfileModal()
  };
console.log(cardDetailInfo,'cardDetailInfo')
  const [isAnnouncementModalOpen, setAnnouncementModalOpen] = useState(false);
  const openAnnouncementModal = () => {
    setAnnouncementModalOpen(true);
  };

  const closeAnnouncementModal = () => {
    setAnnouncementModalOpen(false);
  };
  const handleAnnouncementSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeAnnouncementModal()
  };


  
  const [isBlogModalOpen, setBlogModalOpen] = useState(false);
  const openBlogModal = () => {
    setBlogModalOpen(true);
  };

  const closeBlogModal = () => {
    setBlogModalOpen(false);
  };
  const handleBlogSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeBlogModal()
  };
  const renderInput = (type: string, value: any, field: string, idx: number) => {
  
    switch (type) {
      case 'checkbox':
        return (
          <InputContainer
            onValueChange={(event: any) =>
              handleFormChange({ value: event, field, idx })
            }
            type={type}
            value={value}
          />
        );
      case 'image':
        return (
          <button onClick={() => changeCardFile(idx, field, 'image')}>
            <img src={value} className="w-12 h-12" alt="Card image" />
            <FaCamera className="ml-4" />
          </button>
        );
      case 'video':
        return (
          <button onClick={() => changeCardFile(idx, field, 'video')} className="text-blue-500">
            <video src={value} className="w-12 h-12" />
            <FaVideo className="ml-4" />
          </button>
        );
      case 'text':
      case 'email':
      case 'number':
        return (
          <InputContainer
            onValueChange={(event: any) =>
              handleFormChange({ value: event.target.value, field, idx })
            }
            type={type}
            value={value}
          />
        );
      default:
        return null;
    }
  };


  const renderInputCollections = (type: string, value: any, field: string, idx: number) => {
   
    switch (type) {
      case 'checkbox':
        return (
          <InputContainer
          isDisabled
          showToolTip
            onValueChange={(event: any) =>
              handleFormChange({ value: event, field, idx })
            }
            type={type}
            value={value}
          />
        );
      case 'image':
        return (
          <button  disabled onClick={() => changeCardFile(idx, field, 'image')}>
            <img src={value} className="w-12 h-12" alt="Card image" />
            <FaCamera className="ml-4" />
          </button>
        );
      case 'video':
        return (
          <button disabled  onClick={() => changeCardFile(idx, field, 'video')} className="text-blue-500">
            <video src={value} className="w-12 h-12" />
            <FaVideo className="ml-4" />
          </button>
        );
      case 'text':
      case 'email':
      case 'number':
        return (
          <InputContainer
          isDisabled
          showToolTip
            onValueChange={(event: any) =>
              handleFormChange({ value: event.target.value, field, idx })
            }
            type={type}
            value={value}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
       
           <InputContainer
          label="Card Type"
          labelField="Text"
          list={cardTypes}
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'CardTypeId',
            )
          }}
          optionName='Choose Card Type'
          type="select"
          value={webPageCards.CardTypeId}
          valueField="Value"
        />

 {webPageCards.CardTypeId === 20 && (
        
           
        <button 
        onClick={openBrandMappingModal} 
        className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
        Update Brand Mapping
      </button>
         
        )}

 
 {webPageCards.CardTypeId === 30 && (
       
           
            <button 
              onClick={openTemplateModal} 
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
              Update Template Mapping
            </button>
        
        )}

{webPageCards.CardTypeId === 50 && (
       
           
            <button 
              onClick={openSocialProfileModal} 
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
              Update Social Profile
            </button>
       
        )}
        {webPageCards.CardTypeId === 60 && (
       
           
       <button 
         onClick={openAnnouncementModal} 
         className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
         Update Announcement
       </button>
  
   )}
   {webPageCards.CardTypeId === 70 && (  
       <button 
         onClick={openBlogModal} 
         className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
         Update Blog Post
       </button>
  
   )}
   {webPageCards.CardTypeId === 40 && (
        <div className="flex items-center space-x-4">
          {imageUrls.map((url, index) => (
            <img key={index} src={url} alt="Uploaded" className="w-12 h-12" />
          ))}
          <FaCamera className="cursor-pointer" onClick={openModal} />
        </div>
      )}
       {webPageCards.CardTypeId === 80 && (
          <button
          onClick={handleOpenModal}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
        >
         Categories on Top Menu
        </button>
  
      )}{webPageCards.CardTypeId && webPageCards.CardTypeId === 90 && (
       
           
        <button 
          onClick={openHelpTopicModal} 
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
          Create Help Topics
        </button>
   
    )}
</div>


        {(webPageCards?.CardTypeId === 10 || webPageCards?.CardTypeId === 0) &&
         <AccordionContainer
    child={
     
    <><div className="flex justify-end">

            {cardValues[0]?.product && (
              <button onClick={handleOpenProductModal} type="button" className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3">
                Add Products
              </button>
            )}
            {cardValues[0]?.category && (
              <button onClick={handleOpenModal} type="button" className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3">
                Add Categories
              </button>
            )}</div><div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Delete</th>
                    {cardTemplate?.map((template: any) => (
                      <th key={template.field} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{template.field}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {cardValues && cardValues?.map((cardData: any, index: any) => (
                    <tr key={index} className={`${index % 2 === 0 ? 'bg-blue-100' : 'bg-white'}`}>
                      <td key={9} className="flex px-5 w-max flex-row justify-start item-baseline cursor-pointer pt-6 space-x-2">
                        <button
                          className="text-red-500 hover:text-red-700"
                          onClick={async () => deletewebPageCardItem(cardData, index)}
                        >
                          <HiOutlineTrash className="w-6 h-6" />
                        </button>
                      </td>
                      {cardTemplate?.map((template: any) => (
                        <td key={`${template.field}-${index}`} className="px-6 py-4 whitespace-nowrap">
                          {(cardValues[0]?.product || cardValues[0]?.category) && renderInputCollections(template.type, cardData[template.field], template.field, index)}
                          {!cardValues[0]?.product && !cardValues[0]?.category && renderInput(template.type, cardData[template.field], template.field, index)}

                          {template.type === 'product' && (
                            <div className="m-2 flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          )}
                          {template.type === 'category' && (
                            <div className="m-2 flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"
                                  fill="currentColor" />
                              </svg>
                            </div>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* <CollectionModalComponet
              isModalOpen={isModalOpen}
              handleCloseModal={handleCloseModal}
              categoryColumnData={categoryColumnDefs}
              categoryRowData={categories}
              setPageData={setPageData}
              categoriesPaginationData={categoriesPaginationData}
              onSelect={onSelect}
              additionButtons={additionButtons}
              productColumnData={productColumnDefs}
              productRowData={products}
              productsPaginationData={productsPaginationData}
              isModalProductOpen={isModalProductOpen}
              handleCloseProductModal={handleCloseProductModal} /> */}
              </>
 }
 expandedPanel="Update Card Information"
 headerTitle="Update Card Information"
/>}
{isModalMediaOpen &&
        <div className="fixed inset-0 ml-80 mt-40 flex w-[1000px] h-[400px] items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg w-full  overflow-y-auto">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold mb-4">Add URL</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <FaTimes className="w-6 h-6" />
              </button>
            </div>
            <UploadFilesContainer onSave={handleSaveUrls} cardDetailInfo={cardDetailInfo}/>
            
      
      </div></div>
      }

{isBrandMappingModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Brand Mapping</h2>
        <button onClick={closeBrandMappingModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <BrandMappingContainer onSubmit={handleBrandMappingsSubmit} cardDetailInfo={cardDetailInfo}/>
      </div>
    </div>
  </div>
)}


{isTemplateModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Templates</h2>
        <button onClick={closeTemplateModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <TemplateContainer onSubmit={handleTemplatesSubmit}cardDetailInfo={cardDetailInfo} />
      </div>
    </div>
  </div>
)}
{isHelpTopicModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-[60%] overflow-y-auto overflow-x-auto max-h-[80vh]"> {/* Reduced width to 50% */}
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Help Topics</h2>
        <button onClick={closeHelpTopicModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]"> 
        <HelpTopicContainer onSubmit={handleHelpTopicSubmit} />
      </div>
    </div>
  </div>
)}
{isSocialProfileModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Social Profiles</h2>
        <button onClick={closeSocialProfileModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <SocialProfileContainer onSubmit={handleSocialProfilesSubmit} cardDetailInfo={cardDetailInfo} />
      </div>
    </div>
  </div>
)}

{isAnnouncementModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Announcements</h2>
        <button onClick={closeAnnouncementModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <AnnouncementContainer onSubmit={handleAnnouncementSubmit} cardDetailInfo={cardDetailInfo} />
      </div>
    </div>
  </div>
)}
{isBlogModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-[60%] overflow-y-auto overflow-x-auto max-h-[80vh]"> {/* Reduced width to 50% */}
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Blog Posts</h2>
        <button onClick={closeBlogModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]"> 
        <BlogPostContainer onSubmit={handleBlogSubmit}  cardDetailInfo={cardDetailInfo} />
      </div>
    </div>
  </div>
)}
{handleOpenModal && (
      <CollectionModalComponet
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        categoryColumnData={categoryColumnDefs}
        categoryRowData={categories}
        setPageData={setPageData}
        categoriesPaginationData={categoriesPaginationData}
        onSelect={onSelect}
        additionButtons={additionButtons}
      />  
)}

    </>
  );
};

